import React from "react";

import RegisterAuditory from "@auditory/component/RegisterAuditory";
import SectionPlansNew from "../components/SectionPlans";
import { SectionAction } from "../components/SectionAction";
import { AUDITORY_MODEL, PLANS_MODEL } from "../models/model";
import { PlansProvider } from "../context/PlansContext";

const StepPlans = () => {
  return (
    <PlansProvider>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <SectionPlansNew {...PLANS_MODEL} />
      <SectionAction {...PLANS_MODEL} />
    </PlansProvider>
  );
};

export default StepPlans;
